// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"S0-z"};